/* eslint-disable no-unused-vars */
export const START = 'START'
export const STOP = 'STOP'
export const UPDATE = 'UPDATE'
export const TIMER_PROGRESS = 'TIMER_PROGRESS'

const timerStartAction = data => ({
  type: START,
  data
})
const timerStopAction = data => ({
  type: STOP,
  data
})
const timerUpdateAction = data => ({
  type: UPDATE,
  data
})
  export const timer = payload => dispatch => {
      let data = {}
      const now = Date.now();
     const timer = setInterval(
        () => {},0
      );
      data = {running: true, value:  0 - now, id: payload}
      dispatch(timerStartAction(data))
  }
  export const update = payload => dispatch => {
      let data = {}
      const now = Date.now();
     const timer = setInterval(
        () => {},0
      );
      data = {running: true, value:  payload.value - now, id: payload.id}
      dispatch(timerUpdateAction(data))
  }